
import { useSyncExternalStore } from 'react';

// Tiny pub/sub store letting detail pages (e.g. email detail) override the
// navbar title with dynamic content (e.g. the email subject).
let dynamicTitle: string | null = null;
const listeners = new Set<() => void>();

export const setDynamicPageTitle = (title: string | null) => {
  if (dynamicTitle === title) return;
  dynamicTitle = title;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => dynamicTitle;

export const useDynamicPageTitle = (): string | null =>
  useSyncExternalStore(subscribe, getSnapshot);
